import { cx, useTranslations } from "@jugl-web/utils";
import { CurrencyPicker } from "@jugl-web/ui-components";
import { useInvoicesItemFormPageContext } from "@web-src/modules/invoices/pages/InvoicesItemFormPage/context/useInvoicesItemFormPageContext";
import { CurrencyPickerValue } from "@jugl-web/ui-components/web/CurrencyPicker/types";
import { useEntitySelectedProvider } from "@web-src/modules/entities/providers/EntityProvider/useEntitySelectedProvider";
import { useState } from "react";
import { ReactComponent as ChevronDownIcon } from "./assets/chevron-down.svg";
import { getCurrencySymbol } from "./utils";
import { CurrencyFieldAlert } from "./components/CurrencyFieldAlert";

export const CurrencyField = () => {
  const { t } = useTranslations();
  const { formValues, setFieldValue } = useInvoicesItemFormPageContext();
  const { entity } = useEntitySelectedProvider();
  const [pendingValue, setPendingValue] = useState<CurrencyPickerValue | null>(
    null
  );

  const selectedCurrency = formValues.currency;

  const handleCurrencySelect = (currency: CurrencyPickerValue) => {
    if (entity?.currency !== currency.code) {
      setPendingValue(currency);
    } else {
      setFieldValue("currency", currency.code);
    }
  };

  return (
    <>
      <div className="w-full">
        <label className="mb-2 block pl-2.5 font-secondary text-[15px] font-normal text-dark-700">
          {t({
            id: "invoices.item.currency",
            defaultMessage: "Currency",
          })}
        </label>
        <CurrencyPicker
          value={selectedCurrency}
          onSelect={handleCurrencySelect}
        >
          {(isOpen) => (
            <div className="flex h-[57px] items-center justify-between rounded-xl border border-solid border-grey-400 px-4 text-dark">
              <div className="flex items-center gap-2">
                <span className="font-primary text-grey-600">
                  {getCurrencySymbol(selectedCurrency)}
                </span>
                {selectedCurrency}
              </div>
              <ChevronDownIcon
                className={cx("transition-transform", isOpen && "rotate-180")}
              />
            </div>
          )}
        </CurrencyPicker>
      </div>
      <CurrencyFieldAlert
        isOpen={!!pendingValue}
        onCancel={() => setPendingValue(null)}
        onConfirm={() => {
          if (pendingValue?.code) setFieldValue("currency", pendingValue?.code);
          setPendingValue(null);
        }}
        onRequestClose={() => setPendingValue(null)}
      />
    </>
  );
};
